/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable global-require */
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/functions';
import 'firebase/storage';
import 'firebase/auth';

const key = 'medq-production-version';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const firebaseConfig = ((): Record<string, any> => {
  switch (process.env.REACT_APP_ENV) {
    case 'HOMOLOG':
      return require('./firebase-homolog.json');
    case 'PROD':
      return require('./firebase-prod.json');
    case 'DEV':
    default:
      return require('./firebase-dev.json');
  }
})();

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const app = firebase.app();
export const auth = firebase.auth();
export const database = firebase.database();
export const storage = firebase.storage();
export const functions = app.functions('southamerica-east1');

const clearCacheData = async (): Promise<void> => {
  try {
    const cacheKeys = await caches.keys();

    const allPromises = cacheKeys.map(async (cacheName) => {
      await caches.delete(cacheName);
    });
    await Promise.all(allPromises);
    console.log('remove cache');
    await caches.delete('static');
    console.log('remove static');

    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      const allRegs = regs.map(async (registration) => {
        await registration.unregister();
      });

      await Promise.all(allRegs);
    }

    setTimeout(() => {
      window.location.href = `${window.location.href}`;
    }, 1000);
  } catch (e) {
    // ignore
  }
};

const dbVersion = database.ref('version');
dbVersion.on('value', async (s) => {
  const version = Number(s.val());
  const localKey = localStorage.getItem(key);
  console.log('localVersion:', Number(localKey), 'serverVersion:', version);
  if (!localKey || Number(localKey) !== version) {
    localStorage.setItem(key, String(version));
    await clearCacheData();
  }
});

auth.languageCode = 'pt-br';
export default app;
